import ACTIONS from '~shared/actions';
import { Grow2792Actions, Grow2792StateType } from './types';

export const grow2792State: Grow2792StateType = {
  advantageUsers: 1,
  premierUsers: 1,
  initialLoad: true,
};

export default function Grow2792Reducer(state: Grow2792StateType, action: Grow2792Actions): Grow2792StateType {
  const { type, payload } = action;

  if (type === ACTIONS.PNP_REFRESH_RESET_TOGGLE_SWITCH) {
    return {
      ...state,
      advantageUsers: 1,
    };
  }

  if (type === ACTIONS.PNP_REFRESH_CHANGE_USERS) {
    return {
      ...state,
      [payload.packageType]: payload.users,
    };
  }

  if (type === ACTIONS.PNP_REFRESH_INITIAL_LOAD) {
    return {
      ...state,
      initialLoad: payload.loadedState,
    };
  }

  if (type === ACTIONS.PNP_REFRESH_RESET_ALL) {
    return grow2792State;
  }

  return state;
}
